import { useEffect } from "react";

import Main from "../components/ProductsArvest/Main";
import Active from "../components/ProductsArvest/Active";
import WhatIsTrade from "../components/ProductsArvest/WhatIsTrade";
import CJV from "../components/ProductsArvest/CJV";
import WhyArvest from "../components/Home/WhyArvest";
import ArvestOffers from "../components/Home/ArvestOffers";
import NeedHelp from "../components/Home/NeedHelp";

function ProductsArvest() {
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Main />   
            <Active/> 
            <WhatIsTrade/>
            <CJV/>
            <WhyArvest />
            <ArvestOffers />
            <NeedHelp />
        </div>
    );
}

export default ProductsArvest;
